const nav=document.querySelector('.nav');
    const navBrand=document.querySelector('.brand');
    const mobileNavMenu=document.querySelector('.mobile-nav-menu');
    const mobileNavQuery=matchMedia('(max-width:800px)');
    const setMobileMenu=open=>{nav.classList.toggle('menu-open',open);navBrand.setAttribute('aria-expanded',String(open))};
    navBrand.addEventListener('click',event=>{if(!mobileNavQuery.matches)return;event.preventDefault();setMobileMenu(!nav.classList.contains('menu-open'))});
    mobileNavMenu.addEventListener('click',event=>{if(event.target.closest('a'))setMobileMenu(false)});
    document.addEventListener('click',event=>{if(mobileNavQuery.matches&&nav.classList.contains('menu-open')&&!nav.contains(event.target))setMobileMenu(false)});
    document.addEventListener('keydown',event=>{if(event.key==='Escape')setMobileMenu(false)});
    mobileNavQuery.addEventListener('change',()=>setMobileMenu(false));
    const reduced=matchMedia('(prefers-reduced-motion: reduce)').matches;
    const reveals=[...document.querySelectorAll('.reveal')];
    if(reduced){reveals.forEach(el=>el.classList.add('visible'))}
    else{
      const observer=new IntersectionObserver((entries)=>entries.forEach(entry=>{
        if(entry.isIntersecting){entry.target.classList.add('visible');observer.unobserve(entry.target)}
      }),{threshold:.12});
      reveals.forEach((el,index)=>{el.style.transitionDelay=`${Math.min((index%4)*80,240)}ms`;observer.observe(el)});
    }
